import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import UserDialog from "../../../components/Dialog/UserDialog";
import { useSelectedFightersState } from "../../../providers/SelectedFightersProvider";
import { Api } from "../../../request/api/api";

interface DeleteFightersDialogProps {
  open: boolean;
  onClose: () => void;
  fetchTeam: () => void;
}

export default function DeleteFightersDialog({
  open,
  onClose,
  fetchTeam,
}: DeleteFightersDialogProps) {
  const selectedFightersIds = useSelectedFightersState()
    .fighters.filter((fighter) => fighter.isSelected)
    .map((fighter) => fighter.id);

  const deleteFighter = async () => {
    if (selectedFightersIds.length) {
      const result = await Api.fighter.deleteFighters(selectedFightersIds);
      if (result) {
        onClose();
        fetchTeam();
      }
    }
  };

  return (
    <UserDialog open={open} handleClose={onClose}>
      <DialogTitle>Удалить бойца</DialogTitle>
      <DialogContent>
        <Typography>Вы уверены, что хотите удалить выбранных бойцов?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Назад</Button>
        <Button onClick={deleteFighter}>Удалить</Button>
      </DialogActions>
    </UserDialog>
  );
}
